//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import redirectionlinks from "apis/RedirectionLinks/redirectionlinks"
import { styles } from "./styles";
import { useTranslation } from 'react-i18next';
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryTable from "components/Table/History/HistoryTable";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import searchIcon from 'assets/img/Search_Icon.png';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import useDebounce from 'helpers/useDebounce';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import ThriveServicePlusRequests from 'apis/ThriveServicePlusRequest/ThriveServicePlusRequest';
import { toast } from "react-toastify";
import PreviewToPdf from "./Preview";
import History from "./History";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import ThriveServicePlusPDF from './ThriveServicePlusPDF';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { pdf } from '@react-pdf/renderer';
import { Modal, Backdrop, Fade } from '@material-ui/core';








const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const formFields = [
  { label: "Henry Schein Account Number", key: "henry_schein_account_number" },
  { label: "Title", key: "title" },
  { label: "Practice Owner Name", key: "practice_owner_name" },
  { label: "Point of Contact", key: "point_of_contact" },
  { label: "Office Number", key: "office_number" },
  { label: "Preferred Contact Number", key: "preferred_contact_number" },
  { label: "Email", key: "email" },
  { label: "Practice Name", key: "practice_name" },
  { label: "Street Address", key: "street_address" },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Zip Code", key: "zipcode" },
  { label: "Tier Service Agreement", key: "tier_service_agreement" },
];

export default function ThriveServicePlusRequest(props) {
  const { state, dispatch } = useContext(context);
  // const { getRedirection,searchAPI } = redirectionlinks();

 
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const [history, setHistory] = useState(false);

  
  const [isActive, setIsActive] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const { searchAPI,getserviceplus,servicupdate,getHistory } = ThriveServicePlusRequests();
  const [actionState, setActionState] = useState({ type: '', henryAccount: '' });
  const [open, setOpen] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [reactivateShipto, setReactivateShipto] = useState(false);
  const [approveData, setApproveData] = useState(null);
  const [dormantDialog, setDormantDialog] = useState({
      open: false
    });
  
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
     const [imageType, setImageType] = useState('');
     
  
  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
});
// const { clearSearch } = states;
  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "RESPONSE"] });
  }, []);

  const [states, setstates] = useState({ historyLoader: false,clearSearch: false });
  const [viewHistory, setViewHistory] = useState(false);


  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const handlepdfClose = () => {
    setOpenModal(false);
}

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };
  useEffect(() => {
    if (!states?.clearSearch) {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        }
        else {
          handleGet();
        }
    }
    else {
        setStates({ clearSearch: false });
    }
}, [searchBounceValues, offset,isActive]);

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10
      };
      let res = await getserviceplus(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };
  async function handleSearch() {
    try {
 
      dispatch({ type: 'SET_LOADING', payload: true })

        let values;
        values = {
            search: searchValue,
            offset: (offset - 1) * 10,
            limit: 10,
        };            
        // setResponse({ ...response, filter: false });
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await searchAPI(values);
        if (res) {
          setData(res.data);
          setCount(res.count);
          setRes(true);
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    } catch (e) {
        console.log({ e });
    }
}
const blockInvalidChar = e => ['.', '-','+','ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();

const getPlanName = (plan) => {
  if (!plan) return "-";
  const index = plan.indexOf("-");
  if (index === -1) {
    // If no colon, fallback to first two words
    return plan.split(" ").slice(0, 2).join(" ");
  }
  return plan.substring(0, index).trim();
};

const handleApprove = async (payload) => {
  try {
    const values = {
      henryAccount: {
        ...payload,
        reactivate: payload?.reactivate || false,
      },
    };

    console.log("Request Body", values);

    const res = await servicupdate(values);

    if (res?.result_status == 2 && !payload?.reactivate) {
      setApproveData(payload);
      setDormantDialog({ open: true });
      return;
    }

    if (res?.type === "SUCCESS") {
      handleGet();
      toast.success(res?.message, {
        toastId: "approve-success",
      });
    }

    if (res?.type === "Error") {
      handleGet();
      toast.error(res?.message, {
        toastId: "approve-error",
      });
    }
  } catch (e) {
    console.log(e);
  }
};

const handleClose = () => {
  setOpen(false);
}
// const handlepdfClose = () => {
//   setOpenModal(false);
// }

// const handleDownload = async (rowData) => {
//   const formattedData = {
//     ...rowData,

//       practice_owner_name: `${rowData.practice_owner_first_name} ${rowData.practice_owner_last_name}`,
//       point_of_contact: `${rowData.point_of_contact_first_name} ${rowData.point_of_contact_last_name}`,
//       signature: `${rowData.url}`,
//       triveserviceplusLink: `${rowData.triveserviceplusLink}`,
//       thriveserviceplusprivacyLink: `${rowData.thriveserviceplusprivacyLink}`,
//       thriveserviceplustermconditionLink: `${rowData.thriveserviceplustermconditionLink}`,
//       signaturebase64 : rowData.signature_sign_base64
//   };

//   const blob = await pdf(
//     <ThriveServicePlusPDF formData={formattedData} formFields={formFields} />
//   ).toBlob();

//   const blobUrl = URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = blobUrl;
//   link.download = 'Servive Plus Form.pdf';
//   link.click();

//   URL.revokeObjectURL(blobUrl);
// };

return (
  <React.Fragment>
    {viewHistory ? (
      <History goBack={() => setViewHistory(false)} />
    ) : (
      <>
        <Grid container className={classes.root}>
          {/* Your search input, history button */}
          <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}></Grid>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <CssTextField
              placeholder={t('Search for Ship To')}
              type="number"
  onWheel={(e) => e.target.blur()}
              onKeyDown={blockInvalidChar}
              variant="outlined"
              autoComplete="off"
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue && searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGet();
                        }}
                      />
                    ) : (
                      <SearchOutlinedIcon className={classes.searchInputIcon} />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                if (e.target.value.length === 0) {
                  handleGet();
                }
              }}
              onClick={() => setOffset(1)}
            />

            <Button
              className={classes.historyBtn}
              onClick={() => setViewHistory(true)}
            >
              {t('History')}
            </Button>
          </div>
        </Grid>

        <Loader loading={state.loading} top="15%">
          <Grid className={classes.tableDownInResponsive}>
            <Grid item xs={12} sm={12} lg={12}>
              {res ? (
                data && data.length > 0 ? (
                <Table
                  headings={[
                    "S.No",
                    "Ship To",
                    "Name",
                    "Email",
                    "Submitted Date",
                    "Subscription Plan",
                    "Status",
                    "Signature Document",
                      "Review"
                  ]}
                  data={
                    // data &&
                    // data.length > 0 &&
                    data.map((d, i) => [
                      ((offset - 1) * 10) + (i + 1),
                      d?.henry_schein_account_number || "-",
                      d?.practice_name || "-",
                      d?.email || "-",
                      <span>{d?.created_at || d?.createdAt ? moment(d.created_at || d.createdAt).format("YYYY-MM-DD") : "-"}</span>,
                      <span>{getPlanName(d?.tier_service_agreement)}</span>,
                      d?.status || "-",
                      // <span
                      //   style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                      //   onClick={() => {
                      //     setOpen(true);
                      //     setPreviewData({
                      //       ...d,
                      //       practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
                      //       point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
                      //       signature: `${d.url}`,
                      //       triveserviceplusLink: `${d.triveserviceplusLink}`,
                      //       thriveserviceplusprivacyLink: `${d.thriveserviceplusprivacyLink}`,
                      //       thriveserviceplustermconditionLink: `${d.thriveserviceplustermconditionLink}`,
                      //       signaturebase64 : d.signature_sign_base64

                      //     });
                      //   }}
                      // >
                      //   View
                      // </span>,
                      <a
                      key={i}
                      style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                      onClick={() => {
                        setImageType(d?.url);
                        setOpenModal(true);
                      }}
                    >
                      {t("View")}
                    </a>,
                    //    <IconButton
                    //    aria-label="download"
                    //    onClick={() => {
                    //      const updatedData = {
                    //        ...d,
                    //        practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
                    //        point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
                    //        signature: `${d.url}`,
                    //        triveserviceplusLink: `${d.triveserviceplusLink}`,
                    //        thriveserviceplusprivacyLink: `${d.thriveserviceplusprivacyLink}`,
                    //        thriveserviceplustermconditionLink: `${d.thriveserviceplustermconditionLink}`
                    //      };
                 
                    //      setPreviewData(updatedData); // Optional
                    //      handleDownload(d);           // Actual download function
                    //    }}
                    //  >
                    //    <GetAppIcon />
                    //  </IconButton>,
                      
                      <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                        <div
                          style={{
                            padding: "6px 12px",
                            backgroundColor: "red",
                            color: "white",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                         onClick={() => {
                          if (state?.userInfo?.editAction) {
                            handleApprove({
                              type: "Declined",
                              henryAccount: d?.henry_schein_account_number,
                              tier: getPlanName(d?.tier_service_agreement),
                              requestId: d?.id,
                            });
                          } else {
                            toast.error(state.userInfo?.editAccess);
                          }
                        }}
                        >
                          Decline
                        </div>
                        <div
                          style={{
                            padding: "6px 12px",
                            backgroundColor: "green",
                            color: "white",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                                                  onClick={() => {
                            if (state?.userInfo?.editAction) {
                              handleApprove({
                                type: "Approved",
                                henryAccount: d?.henry_schein_account_number,
                                tier: getPlanName(d?.tier_service_agreement),
                                requestId: d?.id,
                              });
                            } else {
                              toast.error(state.userInfo?.editAccess);
                            }
                          }}
                        >
                          Approve
                        </div>
                      </div>
                    ])
                  }
                  offset={offset}
                  count={
                    (count / 10) % 1 === 0
                      ? Math.floor(count / 10)
                      : Math.floor(count / 10 + 1)
                  }
                  handlePagination={handlePagination}
                />
                ) : (
                  // Show folder icon and message when no data
                  <div className={classes.emptyDataText}>
                    <div>
                      <FolderOpenIcon className={classes.emptyDataIcon} />
                    </div>
                    <div className={classes.errorMsg}>
                      <b>No Data Found</b>
                    </div>
                  </div>
                )
              ) : (
                <Loader Loading={true} top="15%" />
              )}
              {openModal && (
                                    <Modal
                                      className={classes.modal}
                                      open={openModal}
                                      onClose={handlepdfClose}
                                      closeAfterTransition
                                      BackdropComponent={Backdrop}
                                      BackdropProps={{
                                        timeout: 300,
                                      }}
                                    >
                                      <Fade in={openModal} timeout={300} className={classes.img}>
                                        
                                          <iframe src={imageType} width='800' height='600'></iframe>
                                       
                                      </Fade>
                                    </Modal>
                                  )}
                                </Grid>
                              </Grid>
                            </Loader>

                                  <Dialog
                            open={dormantDialog.open}
                            onClose={() => {
                              setDormantDialog({ open: false });
                              setApproveData(null);
                            }}
                            maxWidth="sm"
                          >
                            <div style={{ padding: 20 }}>
                              <h2>Proceed with Reactivation and Service Plus Enrollment</h2>

                              <p>
                                This Shipto is dormant. Do you want to change it to earning
                                status and proceed with Service Plus enrollment?
                              </p>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  marginTop: 20,
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    setDormantDialog({ open: false });
                                    setApproveData(null);
                                  }}
                                >
                                  No
                                </Button>

                                <Button
                                  color="primary"
                                  variant="contained"
                                  style={{ marginLeft: 10 }}
                                  onClick={() => {
                                    setDormantDialog({ open: false });

                                    if (approveData) {
                                      handleApprove({
                                        ...approveData,
                                        reactivate: true,
                                      });
                                    }
                                  }}
                                >
                                  Yes
                                </Button>
                              </div>
                            </div>
                          </Dialog>

        <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
      </>
    )}
  </React.Fragment>
);
}